import { Button, Grid, Typography, useMediaQuery } from '@mui/material';
import EventIcon from '@mui/icons-material/Event';
import useTranslations from '../global/translation/hooks/translation';
import { useTheme } from '@mui/material/styles';
import { useThemeContext } from '../global/ThemeContext';

const Mission = () => {
  const { currentLanguage, translations } = useTranslations();
  const theme = useTheme();
  const { darkMode } = useThemeContext();
  // Check if the screen is small (mobile)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  // Define shorter texts for mobile if available in translations, otherwise use placeholders
  // You should add actual short versions to your translation files
  const heroText = isMobile
    ? translations.label.heroTextShort?.[currentLanguage] || translations.label.heroText[currentLanguage] // Fallback to full text
    : translations.label.heroText[currentLanguage];

  const buttonText = isMobile ? (currentLanguage === 'en' ? 'Book' : 'Umów się') : currentLanguage === 'en' ? 'Book a training' : 'Umów się na trening';

  return (
    <Grid container color={theme.palette.text.primary} sx={{ bgcolor: darkMode ? '#2c2b33' : '#F9F9F9' }} justifyContent="center">
      <Grid item py={isMobile ? 4 : 12} px={isMobile ? 4 : '4rem'} justifyItems="center">
        <Typography
          variant={isMobile ? 'body1' : 'h6'}
          fontWeight={300}
          textAlign={isMobile ? 'justify' : 'center'}
          gutterBottom
          sx={{ color: darkMode ? '#FFF' : '#000' }}
        >
          {heroText} {/* Use potentially shorter text */}
        </Typography>
        <div style={{ textAlign: 'center', width: '100%' }}>
          <Button
            size="large"
            variant="contained"
            sx={{
              mt: 2,
              bgcolor: theme.palette.primary.main,
              color: darkMode ? '#FFF' : '#FFFFFE',
              fontWeight: 'bold',
              borderRadius: 1,
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                bgcolor: theme.palette.primary.dark,
                transform: 'scale(1.05)',
                boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
              },
            }}
            startIcon={<EventIcon />}
            onClick={() => (window.location.href = 'https://lubie.urbanequestrian.pl/')}
          >
            {buttonText} {/* Use shorter button text on mobile */}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Mission;
